import React from 'react';
import { Link } from 'react-router-dom';
import { legalLinks, navGroups, serviceLinks } from '../../data/navigation';
import { Logo } from './Logo';
export function Footer() {
  return <footer className="bg-ink text-white" data-id="element-154" data-mp="alxa6x54qqwx">
      <div className="mx-auto max-w-[1320px] px-6 pt-16" data-id="element-155" data-mp="akm4usw1db3p">
        <div className="grid gap-12 border-b border-white/10 pb-14 lg:grid-cols-12" data-id="element-156" data-mp="5nlyegv9y6c2">
          <div className="lg:col-span-3" data-id="element-157" data-mp="npsgc30o4tv">
            <Logo inverted data-id="element-158" data-mp="orf7dteafrf" />
            <p className="mt-5 max-w-xs text-[14px] leading-relaxed text-white/60" data-id="element-159" data-mp="q2kxj6ehxl6">
              Avenue Gamal Abdel Nasser, Nouakchott — République Islamique de Mauritanie.
            </p>
            <div className="mt-6 flex gap-2" data-id="element-160" data-mp="3n3u07v2kkwwm">
              {[{
              short: 'f',
              label: 'Facebook'
            }, {
              short: 'X',
              label: 'X / Twitter'
            }, {
              short: 'in',
              label: 'LinkedIn'
            }].map(({
              short,
              label
            }) => <a key={label} href="#" aria-label={label} className="flex h-10 w-10 items-center justify-center rounded-full border border-white/15 text-[13px] font-semibold text-white/70 transition-colors hover:border-leaf hover:text-leaf" data-id="element-161" data-mp="394udwu2j4u3m">
                  {short}
                </a>)}
            </div>
          </div>

          <div className="grid grid-cols-2 gap-10 sm:grid-cols-3 lg:col-span-9 lg:grid-cols-6" data-id="element-162" data-mp="2gbrh4k2wxf5e">
            {navGroups.map(group => <div key={group.label} data-id="element-163" data-mp="382fgproxucgy">
                <Link to={group.path} className="text-[14px] font-semibold text-white hover:text-leaf" data-id="element-164" data-mp="381e4vl03lly6">
                  {group.label}
                </Link>
                <ul className="mt-4 space-y-2.5" data-id="element-165" data-mp="2z1r0cqc2o00w">
                  {group.links.map(link => <li key={link.path} data-id="element-166" data-mp="1io0vvih1j9qq">
                      <Link to={link.path} className="text-[13px] text-white/55 transition-colors hover:text-white" data-id="element-167" data-mp="1imzlzhbrgtal">
                        {link.label}
                      </Link>
                    </li>)}
                </ul>
              </div>)}
            <div data-id="element-168" data-mp="ziw2dvi2xuak">
              <p className="text-[14px] font-semibold text-white" data-id="element-169" data-mp="zkfhvjvww1ba">Services</p>
              <ul className="mt-4 space-y-2.5" data-id="element-170" data-mp="urmdix4cuuzq">
                {serviceLinks.map(link => <li key={link.path} data-id="element-171" data-mp="pu4djw8bfq3v">
                    <Link to={link.path} className="text-[13px] text-white/55 transition-colors hover:text-white" data-id="element-172" data-mp="pt2ryxtobl7w">
                      {link.label}
                    </Link>
                  </li>)}
              </ul>
            </div>
          </div>
        </div>

        <div className="flex flex-col gap-4 py-8 text-[13px] text-white/45 md:flex-row md:items-center md:justify-between" data-id="element-173" data-mp="bucuvi6utljj">
          <p data-id="element-174" data-mp="6wjq8tl78zld">© 2026 Chinguitty Bank. Tous droits réservés.</p>
          <ul className="flex flex-wrap gap-x-6 gap-y-2" data-id="element-175" data-mp="266ji5fd0vss7">
            {legalLinks.map(link => <li key={link.path} data-id="element-176" data-mp="219j7ss9543va">
                <Link to={link.path} className="transition-colors hover:text-white" data-id="element-177" data-mp="216exre8zudwp">
                  {link.label}
                </Link>
              </li>)}
          </ul>
        </div>
      </div>
    </footer>;
}